import type { UseCase } from '@/core/shared'
import type { AccessConfigRepository } from '../domain'

export const changeUserRole: UseCase<AccessConfigRepository, 'changeUserRole'> = (repository) => {
  return async (changeUserRole) => {
    await repository.changeUserRole(changeUserRole)
  }
}
